import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import SaveIcon from "@mui/icons-material/Save";
import styles from "./reportContructor.module.scss";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";

const ItemTypes = {
  FIELD: "field",
};

export const ReportFieldsDnDItem = (props) => {
  const { id, index, moveField, field, onShift, cssColumnWidth, selectFieldId, countFixFields, onSelect , onUpdate} = props;
  const ref = useRef(null);

  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.FIELD,

    drop(item, monitor) {
      if (item.index + 1 !== field.number - countFixFields) {
        onShift(field, item.index);
      }

      return {
        handlerId: monitor.getHandlerId(),
      };
    },

    hover(item, monitor) {
      if (!ref.current) {
        return;
      }

      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      // if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      //   return;
      // }

      // // Dragging upwards
      // if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      //   return;
      // }
      // Time to actually perform the action

      moveField(dragIndex, hoverIndex, item);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.FIELD,
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  return (
    <TooltipWrapper title={`Кликните для редакитрования или перетащите колонку`} position="top">
      <div
        ref={ref}
        style={{ width: `${cssColumnWidth}px`, opacity }}
        className={styles.fieldContainer}
        data-handler-id={handlerId}
        onClick={(e) => {
          e.stopPropagation();
          onSelect(field);
        }}
      >

        {selectFieldId === field.id ? (
          <TooltipWrapper title={`Сохранить`} position="top">
            <SaveIcon
              fontSize="small"
              onClick={(e) => {
                e.stopPropagation();
                onUpdate();
              }}
            />
          </TooltipWrapper>
        ) : null}
        <div>
          {field.dashboard.title} {field.dashboard.measure != null ? `(${field.dashboard.measure})` : null}
        </div>
      </div>
    </TooltipWrapper>
  );
};
